import { ExternalLink } from 'lucide-preact';
import {
  formatPublicationDayLabel,
  publicationDayMs,
} from '../geospatial-intelligence-page/geospatialPublicationRange';
import {
  swarmOperatingModel,
  swarmOriginator,
  swarmRecordLocation,
  swarmSourceLabel,
  swarmSourceUrl,
} from '../../functions/dataFilters/swarmFeed';
import type { Risk } from '../../types/api';

function sourceDateLabel(publicationDate: string | undefined): string {
  const day = publicationDayMs(publicationDate);
  if (day == null) return '—';
  return formatPublicationDayLabel(day) || '—';
}

function MetaField({ label, value, title }: { label: string; value: string; title?: string }) {
  return (
    <>
      <dt>{label}</dt>
      <dd title={title}>{value || '—'}</dd>
    </>
  );
}

export function SwarmFeedCard({ risk }: { risk: Risk }) {
  const originator = swarmOriginator(risk.originator);
  const location = swarmRecordLocation(risk);
  const operatingModel = swarmOperatingModel(risk);
  const sourceUrl = swarmSourceUrl(risk.link_to_source);
  const description = risk.description?.trim();

  return (
    <article className="overview-swarm-feed__card">
      <p className="overview-swarm-feed__description">{description || '—'}</p>
      <dl className="overview-swarm-feed__meta">
        <MetaField
          label="Originator"
          value={originator?.code ?? ''}
          title={originator && originator.code !== originator.label ? originator.label : undefined}
        />
        <MetaField label="Source date" value={sourceDateLabel(risk.publication_date)} />
        <MetaField label="Source" value={swarmSourceLabel(risk)} />
        <MetaField label="Location" value={location?.label ?? ''} />
        <MetaField label="Operating model" value={operatingModel?.label ?? ''} />
      </dl>
      {sourceUrl && (
        <a
          className="overview-swarm-feed__link"
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ExternalLink size={13} aria-hidden="true" />
          <span>Original source</span>
        </a>
      )}
    </article>
  );
}
